import React, { useState } from 'react'
import axios from '@fuse/utils/axios';
import {yupResolver} from '@hookform/resolvers/yup';
import {
    makeStyles
} from '@material-ui/core'
import * as yup from 'yup'
import { Controller, useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import useToast from '@fuse/hooks/useToast';
import ColorPicker from '@fuse/components/ColorPicker'
import { Button, DialogTitle, TextField, TextareaAutosize, Typography, Dialog,DialogContent, DialogActions } from '@mui/material'
import Editor from '@fuse/components/Editor';


const useStyles = makeStyles((theme) => ({
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
}))

const AddServiceStatusFromQuickAction = ({
    handleOpenCloseAddModalEvent,
    openAddStatusModalStateData,
    newDataAddedEvent
}) => {

    const classes = useStyles()
    const dispatch = useDispatch()
    const toast = useToast(dispatch)
    const [color, setColor] = useState({name:'black',code:"#000000"});
	const [description, setDescription] = useState('')
    const defaultValues = {
        status_name: '',
    }

    const schema = yup.object({
        status_name:   yup.string().required('Status name is required!')
            .matches(/^[A-Za-z\s]+$/, 'Status name cannot contain numbers, alphanumeric characters, or special characters!')
            .matches(/\S/, 'Status name cannot be only spaces!')
            .max(30, 'Status name must be at most 30 characters!'),
    })

    const { 
        control, 
        formState:{errors: statusFormErrors}, 
        handleSubmit: statusFormSubmit, 
        trigger,
        reset: statusFormReset 
    } = useForm({
        mode: 'onChange',
        defaultValues,
        resolver: yupResolver(schema)
    });



    function statusFormErrorData(error){
        console.log('statusFormErrorData: ',error);
    }

    function onEditorContentChange(content) {
        setDescription(content)
    }


    const onSubmit = async (data) => {
        await trigger();
        if(Object.keys(statusFormErrors).length !== 0) { 
            return;
        }

        let payload = {
			status_name: data.status_name,
			status_description: description,
			status_color: color
		}
        axios.post('/service-request-status/add', payload).then(response => {                
                statusFormReset(defaultValues)
                setColor({name:'black',code:"#000000"})               
				toast.success('Service ticket status added successfully.')
                newDataAddedEvent(response.data.data.new_status)
            }).catch(err => {
				toast.error(err.response.data.message || 'Something went wrong!')
			})
    }


    return (
        <Dialog
            className="cstm_dialog_modal small text-center"
            open={openAddStatusModalStateData}
            // onClose={handleOpenCloseAddModalEvent}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">
                <div className='heading_holder flexbox_holder items-center w-full'>
                    <h2 className="main_heading">Add Status</h2>
                    <Button className='transparent_icon_btn' onClick={handleOpenCloseAddModalEvent}>
                        <i className="icon ti ti-x" />
                    </Button>
                </div>
            </DialogTitle>
            <DialogContent>
                <div className="text-left">
                    <div className='mb-10'>
                        <Typography className='status_text'>
                            Status Name
                            <span className='required_span'>*</span>
                        </Typography>
                        <Controller
                            name="status_name"
                            // className="mb-16"
                            defaultValue={''}
                            control={control}
                            render={({ field }) => (
                                <>
                                    <TextField
                                        {...field}
                                        variant='outlined'
                                        // label='Status Name'
                                        required
                                        fullWidth
                                        error={!!statusFormErrors.status_name}
                                        helperText={statusFormErrors?.status_name?.message}
                                        FormHelperTextProps={{
                                            style: { 
                                                margin : 0, 
                                                backgroundColor: '#f4f4f4',
                                                width: '100%',
                                                paddingTop: '2px',
                                                fontSize: '10px'
                                            }
                                        }}
                                    />
                                </>
                            )}
                        />
                    </div>
                    <div className='mb-10'>
                        <Typography className='status_text'>
                            Status Description
                            {/* <span className='required_span'>*</span> */}
                        </Typography>
                        <Editor
                            editorContent={description}
                         onEditorContentChange={onEditorContentChange}
                        />
                    </div>
                    <div>
                        <Typography className='status_text'>
                            Choose Color
                        </Typography>
                        <ColorPicker setColor={setColor} color={color}/>
                    </div> 
                </div>
            </DialogContent>
            <DialogActions className="action_footer_holder">
                <Button onClick={handleOpenCloseAddModalEvent} className="secondary_btn">Cancel</Button>
                <Button onClick={statusFormSubmit(onSubmit)} className="primary_btn">
                    Save and Select
                </Button>
            </DialogActions>
        </Dialog>
    );


}

export default  AddServiceStatusFromQuickAction;